













































import Vue from 'vue';

import { GqlAttachment } from './graphql';

export default Vue.extend({
  props: {
    photos: Array as () => GqlAttachment[],
  },
});
